import actions from './actions'
import mutations from './mutations'
import getters from './getters'

let state = {
  attachments: {},
  filters: {},
  chatFilterDialogs: {},
  showScrollToNewMessagesButton: true,
  newMessagesCount: 0
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/chats/index.js